import { render } from "./GroupItem.vue?vue&type=template&id=5e6646b0&ts=true"
import script from "./GroupItem.vue?vue&type=script&lang=ts"
export * from "./GroupItem.vue?vue&type=script&lang=ts"

import "./GroupItem.vue?vue&type=style&index=0&id=5e6646b0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__